
import { mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";

export default {
  components: { currencyConverter },
  props: {
    printMode: {
      default: false
    },
    titles: {
      type: Array,
      default: () => []
    },
    totalObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      channel: "",
      displayAggregate: false
    };
  },
  computed: {
    ...mapState("report", ["products", "summary"])
  }
};
